/** Generated by scripts/millistream-sectors-i18n-import.ts. Do not edit manually. */
export const millistreamSectorsTranslationsEn = {
    level1: {
        basic_materials: 'Basic Materials',
        'consumer_goods_&_services': 'Consumer Goods & Services',
        energy: 'Energy',
        financials: 'Financials',
        health_care: 'Health Care',
        industrials: 'Industrials',
        real_estate: 'Real Estate',
        technology: 'Technology',
    },
    level2: {
        alternative_energy: 'Alternative Energy',
        automobiles: 'Automobiles',
        banks: 'Banks',
        'biotechnology_&_pharmaceuticals': 'Biotechnology & Pharmaceuticals',
        chemicals: 'Chemicals',
        conglomerates: 'Conglomerates',
        'construction_&_materials': 'Construction & Materials',
        consumer_services: 'Consumer Services',
        distribution: 'Distribution',
        'drilling_equipment_&_services': 'Drilling Equipment & Services',
        electrical_equipment: 'Electrical Equipment',
        financial_services: 'Financial Services',
        'food_&_beverage': 'Food & Beverage',
        food_producers: 'Food Producers',
        hardware_manufacturer: 'Hardware Manufacturer',
        health_care_providers: 'Health Care Providers',
        home_products: 'Home Products',
        'industrial_goods_&_services': 'Industrial Goods & Services',
        investment: 'Investment',
        it_services: 'IT Services',
        'media_&_entertainment': 'Media & Entertainment',
        'medical_equipment_&_services': 'Medical Equipment & Services',
        'metals_&_mining': 'Metals & Mining',
        multi: 'Multi',
        'non-renewable': 'Non-Renewable',
        'paper_&_forest_products': 'Paper & Forest Products',
        personal_goods: 'Personal Goods',
        'real_estate_investment_&_services': 'Real Estate Investment & Services',
        'real_estate_management_&_development': 'Real Estate Management & Development',
        renewable: 'Renewable',
        retailers: 'Retailers',
        software: 'Software',
        telecommunications: 'Telecommunications',
        'transport_&_logistics': 'Transport & Logistics',
    },
    level3: {
        agriculture: 'Agriculture',
        airlines: 'Airlines',
        asset_management: 'Asset Management',
        'audio_&_video_streaming': 'Audio & Video Streaming',
        auto_parts: 'Auto Parts',
        'auto_services_&_dealers': 'Auto Services & Dealers',
        automobiles: 'Automobiles',
        basic_metals: 'Basic Metals',
        'betting_&_casino': 'Betting & Casino',
        biofuels: 'Biofuels',
        biotechnology: 'Biotechnology',
        'brewer_&_beverage_provider': 'Brewer & Beverage Provider',
        cannabis: 'Cannabis',
        climate_solutions: 'Climate Solutions',
        'clothes_&_accessories': 'Clothes & Accessories',
        commercial_real_estate: 'Commercial Real Estate',
        community_properties: 'Community Properties',
        'components_&_tools': 'Components & Tools',
        conglomerates: 'Conglomerates',
        construction: 'Construction',
        'consulting_&_installation': 'Consulting & Installation',
        consumer_chemicals: 'Consumer Chemicals',
        consumer_electronics: 'Consumer Electronics',
        cosmetics: 'Cosmetics',
        'credit_&_consumer_finance': 'Credit & Consumer Finance',
        'cryptocurrency_&_platform_provider': 'Cryptocurrency & Platform Provider',
        cybersecurity: 'Cybersecurity',
        data_storage: 'Data Storage',
        defense: 'Defense',
        delivery_services: 'Delivery Services',
        digital_platforms: 'Digital Platforms',
        digital_services: 'Digital Services',
        distribution: 'Distribution',
        drilling_equipment: 'Drilling Equipment',
        'e-commerce': 'E-Commerce',
        education_services: 'Education Services',
        electrical_components: 'Electrical Components',
        entertainment: 'Entertainment',
        facility_management: 'Facility Management',
        'farming,_ranching,_plantation_&_seafood': 'Farming, Ranching, Plantation & Seafood',
        'financial_exchange_&_data_provider': 'Financial Exchange & Data Provider',
        food_distributors: 'Food Distributors',
        food_products: 'Food Products',
        'forestry_&_forest_products': 'Forestry & Forest Products',
        game_producers: 'Game Producers',
        gas: 'Gas',
        'geological_products_&_services': 'Geological Products & Services',
        hardware_equipment: 'Hardware Equipment',
        health_care_facilities: 'Health Care Facilities',
        health_care_services: 'Health Care Services',
        home_construction: 'Home Construction',
        'hotel_&_resort': 'Hotel & Resort',
        household_appliances: 'Household Appliances',
        household_items: 'Household Items',
        hydrogen: 'Hydrogen',
        industrial_appliances: 'Industrial Appliances',
        industrial_chemicals: 'Industrial Chemicals',
        insurance: 'Insurance',
        investment_companies: 'Investment Companies',
        it_consulting: 'IT Consulting',
        materials: 'Materials',
        'media_&_publishing': 'Media & Publishing',
        medical_equipment: 'Medical Equipment',
        medical_services: 'Medical Services',
        mostly_renewable: 'Mostly Renewable',
        office: 'Office',
        oil: 'Oil',
        other_consumer_services: 'Other Consumer Services',
        paper_products: 'Paper Products',
        'payment_solutions_&_transactions': 'Payment Solutions & Transactions',
        personal_care: 'Personal Care',
        pharmaceuticals: 'Pharmaceuticals',
        'power_outlets_&_charging_stations': 'Power Outlets & Charging Stations',
        precious_metals: 'Precious Metals',
        'process_&_automation': 'Process & Automation',
        public_transports: 'Public Transports',
        rare_earth_metals: 'Rare Earth Metals',
        real_estate_development: 'Real Estate Development',
        residental: 'Residental',
        'saas-provider': 'SaaS-Provider',
        'savings_&_investment': 'Savings & Investment',
        security_services: 'Security Services',
        semiconductors: 'Semiconductors',
        shipping: 'Shipping',
        solar: 'Solar',
        spac: 'SPAC',
        space_industry: 'Space Industry',
        staffing_services: 'Staffing Services',
        stores: 'Stores',
        supplements: 'Supplements',
        'telecommunications_-_equipment': 'Telecommunications - Equipment',
        'telecommunications_-_service_provider': 'Telecommunications - Service Provider',
        tobacco_provider: 'Tobacco Provider',
        traditional_banking: 'Traditional Banking',
        'travel_&_leisure': 'Travel & Leisure',
        'trucks_&_heavy_vehicles': 'Trucks & Heavy Vehicles',
        'warehouse_&_logistics': 'Warehouse & Logistics',
        'waste_&_recycling': 'Waste & Recycling',
        water: 'Water',
        wind: 'Wind',
    },
}
